module.exports = __webpack_public_path__ + "img/me-header-background-in.eca5a2f2.png";